<section>
  @if (fieldReading()) {
    <span class="body2">{{ fieldReading() }}</span>
  }
    <span class="body2">{{ fieldName() }}</span>
</section>
